export type PlaceholderColor =
    | 'red'
    | 'blue'
    | 'green'
    | 'yellow'
    | 'purple'
    | 'orange'
    | 'pink'
    | 'brown'
    | 'gray'
    | 'black'
    | 'white'
    | 'cyan'
    | 'magenta'
    | 'lime'
    | 'teal';

export const getColorPlaceholder = (color: PlaceholderColor, width: number = 100, height: number = 100): string =>
    `data:image/svg+xml;base64,${btoa(
        `<svg xmlns='http://www.w3.org/2000/svg' width='${width}' height='${height}'>
            <rect width='100%' height='100%' fill='${color}'/>
        </svg>`
    )}`;
